import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { trackReducer } from './reducers/track'
import { artistReducer } from "./reducers/artist";
import {projectReducer} from "./reducers/project";

export const store = configureStore({
  reducer: {
    track: trackReducer,
    artist: artistReducer,
    project: projectReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false,
  }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
